(()=>{'use strict';
let mode='incl';try{mode=sessionStorage.getItem('eq-vat-display')==='excl'?'excl':'incl'}catch{}
const prices=new Set();
function mountControls(){
 const template=document.getElementById('eq-vat-control-template');
 if(!template||!template.content.firstElementChild)return;
 document.querySelectorAll('#main-content .product-info,#main-content .ef-info').forEach(info=>{
   const price=Array.from(info.querySelectorAll('.product-info__price,[data-eq-main-price],.ef-price,.rack-price')).find(el=>el.getClientRects().length&&!el.closest('.eq-standard-redundant'));
   if(!price)return;
   let control=info.querySelector('.eq-vat-inline');
   info.querySelectorAll('.eq-vat-inline').forEach(el=>{if(el!==control)el.remove()});
   if(!control){control=template.content.firstElementChild.cloneNode(true);control.classList.add('eq-vat-inline')}
   if(price.previousElementSibling!==control)price.before(control);
 });
}
function refresh(){
 mountControls();
 document.querySelectorAll('.eq-vat-global').forEach(el=>{el.hidden=false});
 document.querySelectorAll('[data-eq-vat]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.eqVat===mode)));
 document.querySelectorAll('[data-eq-vat-net-only]').forEach(el=>{el.hidden=mode!=='excl'});
 document.querySelectorAll('[data-eq-vat-label]').forEach(el=>{const text=mode==='excl'?el.dataset.excl:el.dataset.incl;if(el.textContent!==text)el.textContent=text});
 prices.forEach(el=>el.draw());
}
function set(value){mode=value==='excl'?'excl':'incl';try{sessionStorage.setItem('eq-vat-display',mode)}catch{}refresh();document.dispatchEvent(new CustomEvent('eq:vat-change',{detail:{mode}}))}
window.EquistoreVat={get mode(){return mode},set};
class EqStorePrice extends HTMLElement{
 connectedCallback(){if(!this.shadowRoot)this.attachShadow({mode:'open'});prices.add(this);this.draw()}
 disconnectedCallback(){prices.delete(this)}
 draw(){const net=Number(this.dataset.net);if(mode==='excl'&&Number.isFinite(net)){const text=new Intl.NumberFormat(document.documentElement.lang||'sv-SE',{style:'currency',currency:this.dataset.currency||'SEK',minimumFractionDigits:2,maximumFractionDigits:2}).format(net/100);if(this.shadowRoot.textContent!==text)this.shadowRoot.textContent=text}else if(!this.shadowRoot.querySelector('slot')){this.shadowRoot.replaceChildren(document.createElement('slot'))}}
}
if(!customElements.get('eq-store-price'))customElements.define('eq-store-price',EqStorePrice);
document.addEventListener('click',e=>{const button=e.target.closest('[data-eq-vat]');if(button)set(button.dataset.eqVat)});
function start(){refresh();new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))refresh()}).observe(document.body,{childList:true,subtree:true});document.addEventListener('shopify:section:load',refresh)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


